import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { dddTel } from '../../../../utils/functions'
import { useHistory } from 'react-router'

import { ANCHORS_CONSTANTS } from '../../../../utils/constantsAnchors'

import Render from './RegisterRender'

function Register ({ ancoraid }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({
    status: 'Ativo'
  })
  const [getLoading, setLoading] = useState(true)
  const [getErros, setErros] = useState([])
  const [getCargos, setCargos] = useState([])

  const dispatch = useDispatch()

  const handleInputChange = (event) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const getInfoForForm = async () => {
    try {
      const findCargos = await api.get('Cargos/Consultar?status=Ativo')
      setCargos(findCargos.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-contatos'))

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Cadastrar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()
      setLoading(true)
      try {
        const response = await api.post('AncorasContatos', {
          ...inputs,
          cargoId: inputs.cargoId ? parseInt(inputs.cargoId) : 0,
          ancoraId: parseInt(ancoraid),
          ddd1: inputs.telefone1 && dddTel(inputs.telefone1, 'ddd'),
          ddd2: inputs.telefone2 && dddTel(inputs.telefone2, 'ddd'),
          telefone1: inputs.telefone1 && dddTel(inputs.telefone1),
          telefone2: inputs.telefone2 && dddTel(inputs.telefone2)
        })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({})
          toast.success('Contato registrado com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []
            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)
              toast.error(ANCHORS_CONSTANTS[resposta.key] + ' - ' + resposta.message)
              return null
            })
            setErros(errosArray)
          } else {
            toast.error('Não foi possível adicionar o novo contato!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getErros={getErros}
    setErros={setErros}
    ancoraid={ancoraid}
    getCargos={getCargos}
    onSubmit={handleSubmit}
  />
}

export default Register
